import React, { useState, useEffect } from 'react';
import {
    Button,
    MenuItem,
    withStyles,
    makeStyles,
    Grid,
    Theme,
} from '@material-ui/core';
import { DefaultRootState, useDispatch, useSelector } from 'react-redux';
import { AddEditTeamLead } from '../../store/actions/cmActionCreator';
import Modal from './Modal';
import { CustomTextField } from '../Textfield';
import { getHubList } from '../../store/actions/staffActionCreator';
import { enqueueSnackbar } from '../../store/actions/notificationActionCreator';
import ListSubItem from '../UI/ListSubItem';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        marginTop: '12px',
        marginBottom: '24px',
    },
    chip: {
        margin: theme.spacing(0.5),
        '&$deleteIconOutlinedColorPrimary': {
            color: 'red',
        },
    },
}));

interface ViewPassbookModalProps {
    open: boolean;
    onClose: () => void;
    isEdit?: boolean;
    data?: any;
    ref?: React.Ref<any>;
    tlRiderInfo?: any;
}

const ViewPassbookModal: React.FC<ViewPassbookModalProps> = ({
    open,
    onClose,
    isEdit = false,
    data = {},
}) => {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(open);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
        onClose?.();
    };
    const actions = [
        <Button
            key={1}
            variant="contained"
            color="default"
            className="cancelButton"
            onClick={handleClose}
            disableElevation
        >
            Close
        </Button>,
    ];

    return (
        <Modal
            onClose={handleClose}
            open={isOpen}
            title={`Passbook ${data?.date}`}
            actions={actions}
            loading={isLoading}
            subtitle={undefined}
            maxWidth={undefined}
            className={undefined}
            fullScreen={undefined}
            isForm={undefined}
            onSubmit={undefined}
            subtitleStyle={undefined}
        >
            {!!data?.subLineItemsUpdated?.length &&
                data?.subLineItemsUpdated?.map((item: any, key: number) => (
                    <ListSubItem key={`sub-item-${key}`} item={item} />
                ))}
        </Modal>
    );
};

export default ViewPassbookModal;
